import React, {useState} from 'react';
import faq_plus from "../images/faq_plus.svg";

const FaqItem = ({question, answer}) => {
    const [open, setOpen] = useState(false)
    return (
        <div className = {open ? `faq_item open` : "faq_item"} onClick={() => {
            setOpen(!open)
        }}>
            <div className="faq_question">
                {question}
                <img src={faq_plus} alt=""/>
            </div>
            <div className = "faq_answer">
                {answer}
            </div>

        </div>
    );
};

export default FaqItem;